import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {QuestionBankStore, SelectPresetPayload} from './types';

const initialState: QuestionBankStore = {};

const slice = createSlice({
    name: 'question-list',
    initialState,
    reducers: {
        selectPreset(state, action: PayloadAction<SelectPresetPayload>) {
            const {preset} = action.payload;

            state.preset = preset;
        },
        deselectPreset(state) {
            state.preset = undefined;
        }
    }
});

const {actions, reducer} = slice;

export const {deselectPreset, selectPreset} = actions;

export default reducer;
